import angular from "angular";
import resellersModule from "../resellersModule.js";
import { NumberFormatting } from "Roblox";

function lineChartController(resellersConstants, highchartsService, $timeout) {
    "ngInject";
    var ctrl = this;

    const render = function () {
        var chartData = Object.assign({}, resellersConstants.highCharts.defaultConfiguration);

        chartData.colors = [resellersConstants.highCharts.colors.lineColor];
        chartData.chart.height = resellersConstants.highCharts.lineChartHeight;
        chartData.data = highchartsService.toHighChartsData(ctrl.chartDataPoints);

        chartData.xAxis.min = highchartsService.getDateMinusDays(ctrl.days);
        chartData.xAxis.labels = {
            format: "{value:%m/%d}"
        };

        chartData.yAxis = {
            title: {
                text: ""
            },
            labels: {
                formatter: function () {
                    return NumberFormatting.abbreviatedFormat(this.value);
                }
            }
        };
        
        var element = angular.element("#" + ctrl.lineChartId);
        element.highcharts(chartData);

        ctrl.highcharts = element.highcharts();
    };
    
    const init = function () {
        var uniqueId = new Date().getTime();
        ctrl.lineChartId = "line_chart_" + uniqueId;

        // https://stackoverflow.com/a/22541080/1663648
        $timeout(render);
    };

    const update = function () {
        if (ctrl.highcharts) {
            ctrl.highcharts.xAxis[0].update({
                min: highchartsService.getDateMinusDays(ctrl.days)
            });
        }
    };

    ctrl.$onInit = init;
    ctrl.$onChanges = update;
}

resellersModule.controller("lineChartController", lineChartController);
export default lineChartController;
